import { isInIframe } from "shared/utils/iframe";
import { IframeDisplayBehaviour } from "./IframeDisplayBehaviour";
import { WebDisplayBehaviour } from "./webDisplayBehaviour";

export function getDisplayBehaviour() {
  if (isInIframe) {
    return new IframeDisplayBehaviour();
  } else {
    return new WebDisplayBehaviour();
  }
}
